import DefaultCurrency from "components/DefaultCurrency";
import { useFormContext } from "contexts/FormContext";
import React, { useEffect, useState } from "react";
import { Col, Container, Form, Image, Row } from "react-bootstrap";
import {
  ArrowDownUp,
  Dash,
  LockFill,
  Plus,
  Trash,
} from "react-bootstrap-icons";
import CurrencyFormat from "react-currency-format";
import Select from "react-select";
import PlaceHolder from "assets/placeholder.webp";
import { useAppContext } from "contexts/AppContext";

const CartItem = ({ index, cartItem }) => {
  // contexts
  const { appState } = useAppContext();
  const { formState, removeDetail, bulkAdjustDetails } = useFormContext();

  // states
  const [price, setPrice] = useState(cartItem.price);
  const [qty, setQty] = useState(cartItem.qty);

  // functions
  const getItemData = (cartItem, val) => {
    const item = appState.resources.salesItems.find(
      (x) => x.id === val.value.id
    );

    const pld = formState.info.priceList?.details.find(
      (pl) => pl.item.id == item.id
    );
    const p = pld ? pld.suggestedSalesPrice : item.suggestedSalesPrice;

    bulkAdjustDetails(cartItem, {
      item: item,
      price: p,
      selectedValue: val,
    });
    setPrice(p);
  };

  // effects
  useEffect(() => {
    if (cartItem.extra) {
      bulkAdjustDetails(cartItem, {
        selectedValue: {
          label:
            cartItem.item.displayName +
            (cartItem.item.secondaryDisplayName &&
              ` (${cartItem.item.secondaryDisplayName})`),
          value: cartItem.item,
        },
      });
    }
  }, []);

  useEffect(() => {
    const d = formState.details.find((x) => x.uid === cartItem.uid);
    if (d) {
      setPrice(d.price);
      setQty(d.qty);
    }
  }, [formState.details]);

  useEffect(() => {
    const d = formState.details.find((x) => x.uid === cartItem.uid);
    if (d.extra) {
      bulkAdjustDetails(d, {
        selectedValue: {
          label:
            d.item.displayName +
            (d.item.secondaryDisplayName &&
              ` (${d.item.secondaryDisplayName})`),
          value: d.item,
        },
      });
    }
  }, []);

  return (
    <Container fluid key={cartItem.uid} className="border-bottom py-2">
      <Row>
        <Col xs={12} md={4} lg={2} className="">
          <Image
            className="w-100 h-100 object-fit-contain"
            src={cartItem.item.image != "" ? cartItem.item.image : PlaceHolder}
            onErrorCapture={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = PlaceHolder;
            }}
          />
        </Col>
        <Col xs={12} md={8} lg={10}>
          <Row>
            <Col sm={1} className="">
              {index + 1}.
            </Col>
            <Col sm={10}>
              {!cartItem.extra && (
                <React.Fragment>
                  {cartItem.item.displayName}-{" "}
                  <span className="h6">
                    <ArrowDownUp  size={16}/>
                    <DefaultCurrency
                      value={
                        cartItem.item.suggestedSalesPrice -
                        cartItem.item.minSalesPrice
                      }
                      decimalScale={2}
                    />
                  </span>
                  <p className="h6 fw-normal text-muted">
                    {cartItem.item.secondaryDisplayName}
                  </p>
                </React.Fragment>
              )}
              {cartItem.extra && (
                <Select
                  isLoading={cartItem.fetchingItemData}
                  value={cartItem.selectedValue}
                  onChange={(val) => getItemData(cartItem, val)}
                  isDisabled={cartItem.locked}
                  options={formState.allItems.map((x) => ({
                    value: x,
                    label:
                      x.displayName +
                      (x.secondaryDisplayName &&
                        ` (${x.secondaryDisplayName})`),
                  }))}
                />
              )}
            </Col>
            <Col sm={1} className="text-danger">
              {!cartItem.locked && (
                <Trash
                  onClick={() => removeDetail(cartItem)}
                  className="cursor-pointer"
                  size={16}
                />
              )}
              {cartItem.locked && <LockFill size={16}/>}
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col xs={12} md={8} lg={9} className="p-0">
          <Form onSubmit={(e) => {}}>
            <Row>
              <Col
                xs={3}
                className="d-flex justify-content-center align-items-center"
              >
                {!cartItem.locked && (
                  <Dash
                    size={30}
                    className="border rounded-circle p-1 cursor-pointer"
                    onClick={() => {
                      const _p = Math.max(0, parseFloat(price) - 0.5);
                      bulkAdjustDetails(cartItem, { qty, price: _p });
                      setPrice(_p);
                    }}
                  />
                )}
              </Col>
              <Col xs={6} className="p-0">
                <CurrencyFormat
                  value={price}
                  prefix="$"
                  inputMode="decimal"
                  allowNegative={false}
                  decimalScale={2}
                  disabled={cartItem.locked}
                  onValueChange={(values) => setPrice(values.value || 0)}
                  onBlur={() =>
                    bulkAdjustDetails(cartItem, {
                      qty,
                      price: parseFloat(price),
                    })
                  }
                  className="form-control border-0 border-bottom text-center"
                  style={{
                    backgroundColor:
                      parseFloat(price) < cartItem.item.minSalesPrice
                        ? "lightsalmon"
                        : "",
                  }}
                />
              </Col>
              <Col
                xs={3}
                className="d-flex justify-content-center align-items-center"
              >
                {!cartItem.locked && (
                  <Plus
                    size={30}
                    className="border rounded-circle p-1 cursor-pointer"
                    onClick={() => {
                      const _p = parseFloat(price) + 0.5;
                      bulkAdjustDetails(cartItem, { qty, price: _p });
                      setPrice(_p);
                    }}
                  />
                )}
              </Col>
              <Col
                xs={3}
                className="mt-2 d-flex justify-content-center align-items-center"
              >
                {!cartItem.locked && (
                  <Dash
                    size={30}
                    className="border rounded-circle p-1 cursor-pointer bg-grey"
                    onClick={() => {
                      const _q = Math.max(0, parseFloat(qty) - 1);
                      bulkAdjustDetails(cartItem, { qty: _q, price });
                      setQty(_q);
                    }}
                  />
                )}
              </Col>
              <Col xs={6} className="mt-2 p-0">
                <CurrencyFormat
                  value={qty}
                  inputMode="decimal"
                  decimalScale={2}
                  allowNegative={false}
                  disabled={cartItem.locked}
                  onValueChange={(values) => setQty(values.value || 0)}
                  onBlur={() =>
                    bulkAdjustDetails(cartItem, { qty: parseFloat(qty), price })
                  }
                  className="form-control border-0 border-bottom text-center"
                  style={{
                    backgroundColor:
                      parseFloat(qty) >
                      Math.max(
                        0,
                        formState.levelHistory &&
                          formState.levelHistory[cartItem.item.id]
                      )
                        ? "lightsalmon"
                        : "",
                  }}
                />
              </Col>
              <Col
                xs={3}
                className="mt-2 d-flex justify-content-center align-items-center"
              >
                {!cartItem.locked && (
                  <Plus
                    size={30}
                    className="border rounded-circle p-1 cursor-pointer"
                    onClick={() => {
                      if (cartItem.locked) return;

                      const _q = parseFloat(qty) + 1;
                      bulkAdjustDetails(cartItem, { qty: _q, price });
                      setQty(_q);
                    }}
                  />
                )}
              </Col>
            </Row>
          </Form>
        </Col>
        <Col
          xs={12}
          md={4}
          lg={3}
          className="d-flex align-items-center justify-content-center fw-bold p-0"
        >
          <DefaultCurrency value={price * qty} />
        </Col>
      </Row>
    </Container>
  );
};

export default CartItem;
